<template>
  <header>
    <div id="prism_top"></div>
    <div id="prism_footer"></div>
    
    <div class="row justify-content-center pt-4">
      <div class="col-10">
        <div class="languages center-align py-1">
            <img @click="changeLanguage('pt')" :src="require('@/assets/img/brazil.png')" alt="" class="responsive-img mx-3">
            <img @click="changeLanguage('es')" :src="require('@/assets/img/spain.png')" alt="" class="responsive-img mx-3">
            <img @click="changeLanguage('en')" :src="require('@/assets/img/united-kingdom.png')" alt="" class="responsive-img mx-3">
        </div>
      </div>
    </div>

    <div class="row py-4 justify-content-center">
      <div class="col-6 py-5">
        <b-img v-if="theme == 'theme-engenhao'" :src="require('@/assets/img/logo-eng.png')" width="500" fluid alt="Nave do Conhecimento"></b-img>
        <b-img v-else :src="require('@/assets/img/logo.png')" width="500" fluid alt="Nave do Conhecimento"></b-img>

        <h3 class="mt-3 is-4 unit-name" v-if="unit">{{ unit.short_name }}</h3>
      </div>
    </div>

  </header>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Header',
  methods: {    
    changeLanguage (language) {
      this.$ml.change(language)
    }
  },

  computed: {
    ...mapGetters({
      theme: 'getTheme',
      unit: 'getUnit',
    })
  }
}
</script>

<style scoped>

</style>
